import { render, staticRenderFns } from "./BlogButton.vue?vue&type=template&id=4ede0d0a&scoped=true"
import script from "./BlogButton.vue?vue&type=script&lang=js"
export * from "./BlogButton.vue?vue&type=script&lang=js"
import style0 from "./BlogButton.vue?vue&type=style&index=0&id=4ede0d0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ede0d0a",
  null
  
)

export default component.exports